(() => {
  const groupSelector = 'fieldset.bls__product-option.option_color';
  const swatchSelector = `${groupSelector} label.bls__product-color-swatches[role="radio"]`;

  // Each visible swatch is a Tab stop; the native input stores the selection.
  // Delegation also supports cards inserted after the initial page load.
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;
    event.preventDefault();
    swatch.focus();
    swatch.control?.click();
  });

  document.addEventListener('keydown', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || event.altKey || event.ctrlKey || event.metaKey) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      swatch.click();
      return;
    }

    const direction = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
    if (!direction) return;
    event.preventDefault();
    const swatches = Array.from(swatch.closest(groupSelector).querySelectorAll('label.bls__product-color-swatches[role="radio"]'));
    const next = (swatches.indexOf(swatch) + direction + swatches.length) % swatches.length;
    swatches[next].focus();
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[type="radio"]')) return;
    const group = event.target.closest(groupSelector);
    if (!group) return;
    group.querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = input.nextElementSibling;
      if (!label?.matches('label[role="radio"]')) return;
      label.classList.toggle('active', input.checked);
      label.setAttribute('aria-checked', String(input.checked));
    });
  });
})();
